// extracted by mini-css-extract-plugin
module.exports = {"desc":"ProductPriceChangeDialog_desc__2YKnG"};